import { services } from "../data/content";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { ServiceIcon } from "./ServiceIcons";

// Full services grid on the home page (all 8, matches /services layout).
export default function HomeServicesTeaser() {
  return (
    <section data-testid="home-services-teaser" className="py-24 md:py-32" style={{ backgroundColor: "var(--surface)" }}>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-12">
          <div>
            <div className="overline">Services</div>
            <h2 className="font-serif text-4xl md:text-5xl mt-3" style={{ color: "var(--primary)" }}>
              What I do.
            </h2>
          </div>
          <Link
            to="/services"
            data-testid="home-services-all"
            className="text-sm inline-flex items-center gap-1 link-underline font-semibold"
            style={{ color: "var(--primary)" }}
          >
            Read full detail <ArrowRight size={14} />
          </Link>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px" style={{ backgroundColor: "var(--border-soft)" }}>
          {services.map((s, i) => (
            <motion.article
              key={s.title}
              data-testid={`home-service-${i}`}
              className="relative overflow-hidden p-7 group"
              style={{ backgroundColor: "var(--bg)" }}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.45, delay: Math.min(i * 0.04, 0.3) }}
              whileHover={{ y: -2 }}
            >
              <span className="absolute top-0 left-0 h-[2px] bg-[var(--accent)] w-0 group-hover:w-full transition-all duration-500" />
              <div className="service-icon" style={{ color: "var(--primary)" }}>
                <ServiceIcon name={s.icon} width="36" height="36" />
              </div>
              <div className="mt-5 font-mono text-[10px] font-semibold uppercase tracking-widest" style={{ color: "var(--accent-strong)" }}>
                0{i + 1}
              </div>
              <h3 className="mt-2 font-serif text-xl leading-tight" style={{ color: "var(--primary)" }}>
                {s.title}
              </h3>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
